module.exports = __webpack_public_path__ + "media/images/locations/sm/india-cc74770cf34456798bb2f7a5f9ce7ca5.jpg";